import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import FeedbackPanel from '../components/FeedbackPanel';

export default function FeedbackPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f4f4f7' }}>
      <Header />
      <main style={{ maxWidth: 600, margin: '0 auto', padding: '2.5rem 1.5rem' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none', border: 'none', color: '#1D9E75',
            fontSize: '0.82rem', cursor: 'pointer', padding: 0,
            fontFamily: 'inherit', marginBottom: '1.75rem', width: 'auto',
          }}
        >
          ← Back
        </button>

        <div style={{ marginBottom: '2rem' }}>
          <div style={{
            fontSize: '0.62rem', fontWeight: 700, textTransform: 'uppercase',
            letterSpacing: '0.12em', color: '#1D9E75', marginBottom: '0.5rem',
          }}>
            Share your thoughts
          </div>
          <h1 style={{
            fontSize: '1.75rem', fontWeight: 800, color: '#1a1a2e',
            margin: '0 0 0.75rem', letterSpacing: '-0.02em',
          }}>
            Give feedback
          </h1>
          <p style={{ fontSize: '0.88rem', color: '#666', lineHeight: 1.65, margin: 0 }}>
            GuruOne is an early product. Your honest feedback — good and bad — directly shapes what gets built next.
          </p>
        </div>

        <FeedbackPanel
          guru="General"
          promptSent="General feedback"
          responseReceived=""
          title="How is GuruOne working for you?"
          onComplete={() => {
            setTimeout(() => navigate('/dashboard'), 2000);
          }}
        />
      </main>
    </div>
  );
}
